export default function(date, format, defaultNow = true) {
  // 通过 defaultNow 来区分当 date 为空时，是否默认显示当前时间
  if (typeof format === 'boolean') {
    defaultNow = format
    format = ''
  }
  if (!defaultNow && !date) {
    return ''
  }
  if (date && typeof date === 'string' && date.indexOf('+08:00') < 0) {
    date = date.replace(/-/g, '/')
    date = date.replace('.0', '')
  }
  let _date = !date ? new Date() : new Date(date)
  let _format = format
  /** 年 */
  let YYYY = _date.getFullYear()
  let YY = String(YYYY).substring(2)
  /** 月 */
  let MM = _date.getMonth() + 1
  MM = (Array(2).join(0) + MM).slice(-2)
  let M = _date.getMonth() + 1
  /** 日 */
  let DD = _date.getDate()
  DD = (Array(2).join(0) + DD).slice(-2)
  let D = _date.getDate()
  /** 时 */
  let HH = _date.getHours()
  HH = (Array(2).join(0) + HH).slice(-2)
  let H = _date.getHours()
  /** 分 */
  let mm = _date.getMinutes()
  mm = (Array(2).join(0) + mm).slice(-2)
  let m = _date.getMinutes()
  /** 秒 */
  let SS = _date.getSeconds()
  SS = (Array(2).join(0) + SS).slice(-2)
  let S = _date.getSeconds()
  /** 周 */
  let weeks = ['日', '一', '二', '三', '四', '五', '六']
  let week = weeks[_date.getDay()]
  let out = `${YYYY}年${MM}月${DD}日（星期${week}）${HH}时${mm}分${SS}秒`
  if (_format) {
    _format = _format.replace('yyyy', 'YYYY')
    _format = _format.replace('yy', 'YY')
    _format = _format.replace('dd', 'DD')
    _format = _format.replace('d', 'D')
    _format = _format.replace('hh', 'HH')
    _format = _format.replace('h', 'H')
    _format = _format.replace('ss', 'SS')
    _format = _format.replace('s', 'S')
    _format = _format.replace('YYYY', YYYY)
    _format = _format.replace('YY', YY)
    _format = _format.replace('MM', MM)
    _format = _format.replace('M', M)
    _format = _format.replace('DD', DD)
    _format = _format.replace('D', D)
    _format = _format.replace('HH', HH)
    _format = _format.replace('H', H)
    _format = _format.replace('mm', mm)
    _format = _format.replace('m', m)
    _format = _format.replace('SS', SS)
    _format = _format.replace('S', S)
    out = _format
  }
  return out
}
